export const prefixCls = 'fx-operate-admin'
